import { render, staticRenderFns } from "./DeviceTypeIcon.vue?vue&type=template&id=5722226c&scoped=true&"
import script from "./DeviceTypeIcon.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722226c",
  null
  
)

export default component.exports